<template>
  <div>
    <div :class="className" v-if="isShow">
      <validation-observer ref="shipmentRules">
        <!--Container trucking-->
        <div
          v-if="
            ['2', '5'].includes(service_type.toString()) ||
            (['4'].includes(service_type.toString()) &&
              request_quotation.customs_other_service_type == 'CONTAINER')
          "
        >
          <div class="title">Customer Information</div>
          <b-card class="b-card-bg">
            <b-row>
              <b-col cols="6">
                <validation-provider #default="{ errors }" rules="">
                  <b-form-group>
                    <label>Customer </label>
                    <Select4
                      :class="errors.length > 0 ? 'is-invalid' : null"
                      :disabled="readonly"
                      placeholder="Select Company"
                      @select="
                        ({ text }) => {
                          shipment_on_tms.customer_company_name = text;
                          shipment_on_tms.customer_id = ' ';
                        }
                      "
                      v-model="shipment_on_tms.customer_company_id"
                      :options="{
                        isSearch: true,
                        value: 'id',
                        label: 'text',
                        data: companyItems,
                        fields: [{ field: 'text', label: 'Text' }],
                      }"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="6">
                <validation-provider #default="{ errors }" rules="">
                  <b-form-group>
                    <label>Customer Contact </label>
                    <Select2
                      :class="errors.length > 0 ? 'is-invalid' : null"
                      :disabled="readonly"
                      :key="shipment_on_tms.customer_id"
                      placeholder="Select Customer"
                      v-model="shipment_on_tms.customer_id"
                      :options="customer_list_options"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="6">
                <validation-provider
                  name="Phone"
                  #default="{ errors }"
                  rules=""
                >
                  <b-form-group>
                    <label>Phone </label>
                    <b-form-input
                      :state="errors.length > 0 ? false : null"
                      :disabled="readonlyFrom"
                      v-model="shipment_on_tms.phone"
                      placeholder="Phone"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="6">
                <validation-provider #default="{ errors }" rules="">
                  <b-form-group>
                    <label>Contact WR1 </label>
                    <!-- <Select2
                      :disabled="readonlyFrom"
                      v-model="shipment_on_tms.sale_id"
                      :options="sales"
                    /> -->
                    <Select4
                      :class="errors.length > 0 ? 'is-invalid' : null"
                      :disabled="readonly"
                      v-model="shipment_on_tms.sale_id"
                      :options="{
                        isSearch: true,
                        value: 'id',
                        label: 'text',
                        data: sales,
                        fields: [{ field: 'text', label: 'Text' }],
                      }"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" v-if="false">
                <validation-provider #default="{ errors }" rules="">
                  <b-form-group>
                    <label
                      >Accountable Department
                      {{ shipment_on_tms.acc_dept_tms_id }}
                    </label>
                    <Select2
                      :class="errors.length > 0 ? 'is-invalid' : null"
                      :disabled="readonlyFrom"
                      placeholder="Accountable Department"
                      @select="
                        ({ tms_id }) => {
                          shipment_on_tms.acc_dept_tms_id = tms_id;
                        }
                      "
                      v-model="shipment_on_tms.shipper"
                      :options="acc_dept"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col cols="12">
                <validation-provider
                  name="Shipping type"
                  #default="{ errors }"
                  rules="required"
                >
                  <b-form-group>
                    <label>Shipping type <font class="red">*</font> </label>

                    <Select4
                      :class="errors.length > 0 ? 'is-invalid' : null"
                      :disabled="readonlyFrom"
                      placeholder="Shipping type"
                      v-model="shipment_on_tms.shipping_type"
                      @select="
                        ({ tms_id }) => {
                          shipment_on_tms.shipping_type_tms_id = tms_id;
                        }
                      "
                      :options="{
                        isSearch: true,
                        value: 'id',
                        label: 'text',
                        data:
                          service_type == 5
                            ? transport_types.filter((i) =>
                                [1, 2, 3, 4].includes(i.id)
                              )
                            : service_type == 6
                            ? transport_types.filter((i) =>
                                [1, 2, 3, 4].includes(i.id)
                              )
                            : transport_types.filter((i) =>
                                [1, 2].includes(i.id)
                              ),
                        fields: [{ field: 'text', label: 'Text' }],
                      }"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <!-- <b-col cols="6">
                <validation-provider #default="{ errors }" rules="">
                  <b-form-group>
                    <label>Commodity </label>
                    <Select4
                      :class="errors.length > 0 ? 'is-invalid' : null"
                      :disabled="readonlyFrom"
                      placeholder="Commodity"
                      v-model="shipment_on_tms.goods_type"
                      @select="
                        ({ tms_id }) => {
                          shipment_on_tms.goods_type_tms_id = tms_id;
                        }
                      "
                      :options="{
                        isSearch: true,
                        value: 'id',
                        label: 'text',
                        data: goods_types,
                        fields: [{ field: 'text', label: 'Text' }],
                      }"
                    />

                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col> -->
            </b-row>
          </b-card>
          <div class="title">Cargo Details</div>

          <b-card class="b-card-bg">
            <b-row>
              <!-- <b-col cols="4">
                <validation-provider
                  name="Amount Truck"
                  #default="{ errors }"
                  rules="max_value:100"
                >
                  <b-form-group>
                    <label>Amount Truck </label>
                    <b-form-input
                      :state="errors.length > 0 ? false : null"
                      :disabled="readonlyFrom"
                      v-model="shipment_on_tms.amount_truck"
                      placeholder="Amount Truck"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col> -->

              <!-- ok -->

              <b-col
                cols="12"
                v-for="itemCommodity in shipment_on_tms.valueContainer"
                :key="itemCommodity.id"
                class="mt-1 p-0"
              >
                <b-col lg="12" :key="reloadContainerLine">
                  <b-row class="mt-1">
                    <b-col lg="6">
                      <validation-provider
                        name="Commodity Type"
                        #default="{ errors }"
                        rules="required"
                      >
                        <b-form-group>
                          <label class="flex"
                            >Commodity Type
                            <div class="red">*</div></label
                          >
                          <Select2
                            :disabled="readonly"
                            placeholder="Select Commodity type"
                            v-model="itemCommodity.commodity_type"
                            :options="goods_types"
                          />
                          <small
                            class="text-danger"
                            v-show="errors.length > 0"
                            >{{ errors[0] }}</small
                          >
                        </b-form-group>
                      </validation-provider>
                    </b-col>
                    <b-col lg="6">
                      <validation-provider
                        name="Commodity"
                        #default="{ errors }"
                        rules="required"
                      >
                        <b-form-group>
                          <label class="flex"
                            >Commodity
                            <div class="red">*</div>
                          </label>
                          <b-form-input
                            :state="errors.length > 0 ? false : null"
                            :disabled="readonly"
                            class="iuput"
                            v-model="itemCommodity.commodity"
                            type="text"
                            placeholder="Commodity"
                            required
                          ></b-form-input>
                          <small
                            class="text-danger"
                            v-show="errors.length > 0"
                            >{{ errors[0] }}</small
                          >
                        </b-form-group>
                      </validation-provider>
                    </b-col>

                    <b-col lg="3">
                      <validation-provider
                        name="Container Type"
                        #default="{ errors }"
                        rules="required"
                      >
                        <b-form-group>
                          <label class="flex"
                            >Container Type
                            <div class="red">*</div></label
                          >
                          <Select4
                            :class="errors.length > 0 ? 'is-invalid' : null"
                            :disabled="readonly"
                            placeholder="Container Type"
                            v-model="itemCommodity.cont_type"
                            :options="{
                              isSearch: true,
                              value: 'id',
                              label: 'text',
                              data: cont_types.filter(
                                (i) => i.group === 'Container truck'
                              ),
                              fields: [{ field: 'text', label: 'Text' }],
                            }"
                          />

                          <!-- <Select4
                      :class="errors.length > 0 ? 'is-invalid' : null"
                      :disabled="readonlyFrom"
                      placeholder="Commodity"
                      v-model="shipment_on_tms.goods_type"
                      @select="
                        ({ tms_id }) => {
                          shipment_on_tms.goods_type_tms_id = tms_id;
                        }
                      "
                      :options="{
                        isSearch: true,
                        value: 'id',
                        label: 'text',
                        data: goods_types,
                        fields: [{ field: 'text', label: 'Text' }],
                      }"
                    /> -->
                          <small
                            class="text-danger"
                            v-show="errors.length > 0"
                            >{{ errors[0] }}</small
                          >
                        </b-form-group>
                      </validation-provider>
                    </b-col>
                    <b-col lg="2">
                      <validation-provider
                        name="Quantity"
                        #default="{ errors }"
                        rules="required|minNumber:0"
                      >
                        <b-form-group>
                          <label class="flex"
                            >Quantity
                            <div class="red">*</div>
                          </label>
                          <b-form-input
                            @input="updateContainerLine3(itemCommodity)"
                            :state="errors.length > 0 ? false : null"
                            disabled
                            class="iuput"
                            v-model="itemCommodity.quantity"
                            placeholder="Quantity"
                            type="number"
                            required
                          ></b-form-input>
                          <small
                            class="text-danger"
                            v-show="errors.length > 0"
                            >{{ errors[0] }}</small
                          >
                        </b-form-group>
                      </validation-provider>
                    </b-col>
                    <b-col lg="3">
                      <validation-provider
                        name="Total gross weight (Kgs)"
                        #default="{ errors }"
                        rules="required|minNumber:0"
                      >
                        <b-form-group>
                          <label class="flex"
                            >Total gross weight (Kgs)
                            <div class="red">*</div>
                          </label>
                          <cleave
                            :state="errors.length > 0 ? false : null"
                            :disabled="readonly"
                            :options="$Utils.CONSTANTS.cleaveNumeral"
                            v-model="itemCommodity.total_gross_weight"
                            class="form-control"
                            placeholder="Total gross weight (Kgs)"
                            required
                          />

                          <small
                            class="text-danger"
                            v-show="errors.length > 0"
                            >{{ errors[0] }}</small
                          >
                        </b-form-group>
                      </validation-provider>
                    </b-col>
                    <b-col lg="4">
                      <validation-provider
                        name="Orderdetail ID"
                        #default="{ errors }"
                        rules="required"
                      >
                        <b-form-group>
                          <label class="flex"
                            >Orderdetail ID
                            <div class="red">*</div>
                          </label>

                          <b-form-input
                            :state="errors.length > 0 ? false : null"
                            disabled
                            v-model="itemCommodity.orderDetailId"
                            placeholder="Orderdetail ID"
                          />

                          <small
                            class="text-danger"
                            v-show="errors.length > 0"
                            >{{ errors[0] }}</small
                          >
                        </b-form-group>
                      </validation-provider>
                    </b-col>
                    <b-col lg="12">
                      <b-row
                        class="mt-1"
                        v-for="(item, index) in itemCommodity.containerLine3"
                        :key="index"
                      >
                        <b-col cols="12" lg="4">
                          <b-form-group>
                            <label class="custom-label-shipment"
                              >Container No.</label
                            >
                            <b-form-input
                              placeholder="Container No."
                              :disabled="readonly"
                              v-model="item.container_no"
                            />
                          </b-form-group>
                        </b-col>
                        <b-col cols="12" lg="4">
                          <b-form-group>
                            <label class="custom-label-shipment"
                              >Seal No.</label
                            >
                            <b-form-input
                              placeholder="Seal No."
                              :disabled="readonly"
                              v-model="item.seal_no"
                            />
                          </b-form-group>
                        </b-col>
                        <b-col cols="12" lg="4">
                          <b-form-group>
                            <label class="custom-label-shipment"
                              >Trunk ID</label
                            >
                            <b-form-input
                              placeholder="Trunk ID"
                              disabled
                              v-model="item.truckId"
                            />
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-col>
              <!-- end ok -->
              <b-col cols="6">
                <validation-provider
                  name="Pick up date"
                  #default="{ errors }"
                  rules="required"
                >
                  <b-form-group>
                    <label>Pick up date <font class="red">*</font> </label>

                    <section>
                      <date-picker
                        ref="datePicker"
                        v-model="shipment_on_tms.from_date"
                        type="datetime"
                        class="w-full"
                        :disabled="readonlyFrom"
                        value-type="format"
                        :class="errors.length > 0 ? 'is-invalid' : null"
                        title-format="DD-MM-YYYY"
                        time-title-format="DD-MM-YYYY"
                        placeholder="Select datetime"
                        :show-time-panel="showTimePanel"
                        format="DD-MM-YYYY HH:mm"
                        @close="handleOpenChange"
                      >
                        <template v-slot:footer>
                          <button
                            class="mx-btn mx-btn-text"
                            @click="toggleTimePanel"
                          >
                            {{ showTimePanel ? "Date" : "Time" }}
                          </button>
                        </template>
                      </date-picker>
                    </section>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="6">
                <validation-provider
                  name="Delivery date"
                  #default="{ errors }"
                  rules="required"
                >
                  <b-form-group>
                    <label>Delivery date <font class="red">*</font></label>

                    <section>
                      <date-picker
                        ref="datePicker"
                        v-model="shipment_on_tms.to_date"
                        :disabled-date="disabledRangeDelivery"
                        type="datetime"
                        :disabled="readonlyFrom"
                        :class="errors.length > 0 ? 'is-invalid' : null"
                        class="w-full"
                        value-type="format"
                        title-format="DD-MM-YYYY"
                        time-title-format="DD-MM-YYYY"
                        placeholder="Select datetime"
                        :show-time-panel="showTimePanel"
                        format="DD-MM-YYYY HH:mm"
                        @close="handleOpenChange"
                      >
                        <template v-slot:footer>
                          <button
                            class="mx-btn mx-btn-text"
                            @click="toggleTimePanel"
                          >
                            {{ showTimePanel ? "Date" : "Time" }}
                          </button>
                        </template>
                      </date-picker>
                    </section>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <!-- <b-col cols="6">
              <validation-provider
                name="Delivery date"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Delivery date </label>
                  <section>
                     <date-picker  ref="datePicker"
                      v-model="shipment_on_tms.to_date"
                      :disabled-date="disabledRangeDelivery"
                      type="datetime"
                      class="w-full"
                      :disabled="readonlyFrom"
                      value-type="format"
                      :class="errors.length > 0 ? 'is-invalid' : null"
                      title-format="DD-MM-YYYY"
                      time-title-format="DD-MM-YYYY"
                      placeholder="Select datetime"
                      :show-time-panel="showTimePanel"
                      format="DD-MM-YYYY HH:mm"
                      @close="handleOpenChange"
                    >
                      <template v-slot:footer>
                        <button
                          class="mx-btn mx-btn-text"
                          @click="toggleTimePanel"
                        >
                          {{ showTimePanel ? "Date" : "Time" }}
                        </button>
                      </template>
                    </date-picker>
                  </section>
                   
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col> -->
              <b-col cols="6">
                <validation-provider
                  name="Pickup"
                  #default="{ errors }"
                  rules=""
                >
                  <b-form-group>
                    <label>Pickup </label>

                    <Select4
                      v-model="shipment_on_tms.pickup_location"
                      :class="errors.length > 0 ? 'is-invalid' : null"
                      placeholder="Enter Pick up "
                      @select="
                        ({ tms_id }) => {
                          shipment_on_tms.pickup_location_tms_id = tms_id;
                        }
                      "
                      :key="loadLocations"
                      @reload="$store.dispatch('masterData/fetchLocations')"
                      :disabled="readonlyFrom"
                      :options="{
                        isSearch: true,
                        isReload: true,
                        value: 'id',
                        label: 'text',
                        data: locations,
                        fields: [
                          { field: 'abbreviations', label: 'Abbreviations' },
                          { field: 'name', label: 'Location' },
                          {
                            field: 'address',
                            label: 'Address',
                          },
                        ],
                      }"
                    />

                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="6">
                <validation-provider
                  name="Delivery"
                  #default="{ errors }"
                  rules=""
                >
                  <b-form-group>
                    <label>Delivery </label>

                    <Select4
                      v-model="shipment_on_tms.delivery_location"
                      :class="errors.length > 0 ? 'is-invalid' : null"
                      placeholder="Enter Delivery "
                      @select="
                        ({ tms_id }) => {
                          shipment_on_tms.delivery_location_tms_id = tms_id;
                        }
                      "
                      :key="loadLocations"
                      @reload="$store.dispatch('masterData/fetchLocations')"
                      :disabled="readonlyFrom"
                      :options="{
                        isSearch: true,
                        isReload: true,
                        value: 'id',
                        label: 'text',
                        data: locations,
                        fields: [
                          { field: 'abbreviations', label: 'Abbreviations' },
                          { field: 'name', label: 'Location' },
                          {
                            field: 'address',
                            label: 'Address',
                          },
                        ],
                      }"
                    />

                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col cols="6">
                <validation-provider
                  name="Empty Depot"
                  #default="{ errors }"
                  rules=""
                >
                  <b-form-group>
                    <label>Empty Depot </label>

                    <Select4
                      v-model="shipment_on_tms.deport"
                      :class="errors.length > 0 ? 'is-invalid' : null"
                      placeholder="Empty Depot"
                      @select="
                        ({ tms_id }) => {
                          shipment_on_tms.depot_tms_id = tms_id;
                        }
                      "
                      :disabled="readonlyFrom"
                      :options="{
                        isSearch: true,
                        value: 'id',
                        label: 'text',
                        data: locations,
                        fields: [
                          { field: 'abbreviations', label: 'Abbreviations' },
                          { field: 'name', label: 'Location' },
                          {
                            field: 'address',
                            label: 'Address',
                          },
                        ],
                      }"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="6">
                <!-- <b-form-group>
                  <label>Cut off time </label>
                  <b-form-input
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonlyFrom"
                    v-model="shipment_on_tms.cut_off"
                    placeholder="Cut off time"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group> -->
                <b-form-group>
                  <label>Cut-off</label>

                  <section>
                    <date-picker
                      ref="datePicker"
                      v-model="shipment_on_tms.cut_off"
                      type="datetime"
                      :disabled="readonlyFrom"
                      class="w-full"
                      value-type="format"
                      title-format="DD-MM-YYYY"
                      time-title-format="DD-MM-YYYY"
                      placeholder="Select datetime"
                      :show-time-panel="showTimePanel"
                      format="DD-MM-YYYY HH:mm"
                      @close="handleOpenChange"
                    >
                      <template v-slot:footer>
                        <button
                          class="mx-btn mx-btn-text"
                          @click="toggleTimePanel"
                        >
                          {{ showTimePanel ? "Date" : "Time" }}</button
                        >Carrier
                      </template>
                    </date-picker>
                  </section>
                </b-form-group>
              </b-col>

              <b-col cols="6">
                <validation-provider #default="{ errors }" rules="">
                  <b-form-group>
                    <label>Carrier </label>

                    <Select4
                      v-model="shipment_on_tms.shipping_line"
                      :class="errors.length > 0 ? 'is-invalid' : null"
                      @select="
                        ({ tms_id }) => {
                          shipment_on_tms.shipping_line_tms_id = tms_id;
                        }
                      "
                      placeholder="Carrier"
                      :disabled="readonlyFrom"
                      :options="{
                        isSearch: true,
                        value: 'id',
                        label: 'text',
                        data: shipping_lines,
                        fields: [
                          { field: 'code', label: 'Code' },
                          { field: 'name', label: 'Shipping Line' },
                        ],
                      }"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="6">
                <validation-provider
                  name="BK/HBL/INV"
                  #default="{ errors }"
                  rules=""
                >
                  <b-form-group>
                    <label>BK/HBL/INV </label>
                    <b-form-input
                      :state="errors.length > 0 ? false : null"
                      :disabled="readonlyFrom"
                      v-model="shipment_on_tms.bk_hbl_inv"
                      placeholder="BK/HBL/INV"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col cols="4">
                <validation-provider
                  name="Contact pick up"
                  #default="{ errors }"
                  rules=""
                >
                  <b-form-group>
                    <label>Contact pick up</label>
                    <b-form-input
                      :state="errors.length > 0 ? false : null"
                      :disabled="readonlyFrom"
                      v-model="shipment_on_tms.contact_pickup"
                      placeholder="Contact pick up"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="4">
                <validation-provider
                  name="Contact delivery "
                  #default="{ errors }"
                  rules=""
                >
                  <b-form-group>
                    <label>Contact delivery </label>
                    <b-form-input
                      :state="errors.length > 0 ? false : null"
                      :disabled="readonlyFrom"
                      v-model="shipment_on_tms.contact_delivery"
                      placeholder="Contact delivery"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col cols="4">
                <validation-provider
                  name="WR1’s Branch"
                  #default="{ errors }"
                  rules="required"
                >
                  <b-form-group>
                    <label>WR1’s Branch 
                    <font class="red">*</font>
                      </label>

                    <Select4
                      v-model="shipment_on_tms.wr1_branch"
                      :class="errors.length > 0 ? 'is-invalid' : null"
                      placeholder="WR1’s Branch"
                      :disabled="readonlyFrom"
                      :key="wr1BranchList.length"
                      :options="{
                        isSearch: true,
                        value: 'id',
                        label: 'text',
                        data: wr1BranchList,
                        fields: [
                          { field: 'id', label: 'ID' },
                          {
                            field: 'text',
                            label: 'NAME',
                          },
                        ],
                      }"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
          </b-card>

          <b-row>
            <b-col cols="12">
              <validation-provider #default="{ errors }" rules="">
                <b-form-group>
                  <label></label>
                  <div class="title">Note 1</div>

                  <b-form-textarea
                    class="card"
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonlyFrom"
                    rows="6"
                    v-model="shipment_on_tms.note1"
                    placeholder="Note 1"
                  />

                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12">
              <validation-provider #default="{ errors }" rules="">
                <b-form-group>
                  <div class="title">Note 2 (Billing information)</div>

                  <b-form-textarea
                    class="card"
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonlyFrom"
                    rows="6"
                    v-model="shipment_on_tms.note2"
                    placeholder="Note 2 (Billing information)"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" class="pt-1 pb-1" v-if="!readonlyFrom">
              <a
                @click="sendNewShipmentToTMS"
                class="btn round btn-primary pl-3 pr-3"
                ><feather-icon icon="SendIcon" /> Send To TMS</a
              >
            </b-col>
          </b-row>
        </div>
        <!-- Form Van trucking -->
        <div
          v-if="
            ['1', '3', '6'].includes(service_type.toString()) ||
            (['4'].includes(service_type.toString()) &&
              request_quotation.customs_other_service_type == 'VAN')
          "
        >
          <b-card class="b-card-bg">
            <b-row>
              <b-col cols="6">
                <validation-provider #default="{ errors }" rules="">
                  <b-form-group>
                    <label>Customer </label>

                    <Select4
                      :class="errors.length > 0 ? 'is-invalid' : null"
                      :disabled="readonly"
                      placeholder="Select Company"
                      v-model="shipment_on_tms.customer_company_id"
                      @select="
                        ({ text }) => {
                          shipment_on_tms.customer_company_name = text;
                          shipment_on_tms.customer_id = ' ';
                        }
                      "
                      :options="{
                        isSearch: true,
                        value: 'id',
                        label: 'text',
                        data: companyItems,
                        fields: [{ field: 'text', label: 'Text' }],
                      }"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="6">
                <validation-provider #default="{ errors }" rules="">
                  <b-form-group>
                    <label>Customer Contact </label>

                    <Select4
                      :class="errors.length > 0 ? 'is-invalid' : null"
                      :disabled="readonly"
                      placeholder="Select Customer"
                      v-model="shipment_on_tms.customer_id"
                      :key="customer_list_options.length"
                      :options="{
                        isSearch: true,
                        value: 'code',
                        label: 'text',
                        data: customer_list_options,
                        fields: [{ field: 'text', label: 'Text' }],
                      }"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="6">
                <validation-provider
                  name="Phone"
                  #default="{ errors }"
                  rules=""
                >
                  <b-form-group>
                    <label>Phone </label>
                    <b-form-input
                      :state="errors.length > 0 ? false : null"
                      :disabled="readonlyFrom"
                      v-model="shipment_on_tms.phone"
                      placeholder="Phone"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="6">
                <validation-provider
                  name="Contact WR1"
                  #default="{ errors }"
                  rules=""
                >
                  <b-form-group>
                    <label>Contact WR1 </label>

                    <Select4
                      :class="errors.length > 0 ? 'is-invalid' : null"
                      :disabled="readonlyFrom"
                      placeholder="Select Customer"
                      v-model="shipment_on_tms.sale_id"
                      :key="sales.length"
                      :options="{
                        isSearch: true,
                        value: 'id',
                        label: 'text',
                        data: sales,
                        fields: [{ field: 'text', label: 'Text' }],
                      }"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" v-if="false">
                <validation-provider
                  name="Accountable Department"
                  #default="{ errors }"
                  rules=""
                >
                  <b-form-group>
                    <label>Accountable Department </label>
                    <Select2
                      :class="errors.length > 0 ? 'is-invalid' : null"
                      :disabled="readonlyFrom"
                      @select="
                        ({ tms_id }) => {
                          shipment_on_tms.acc_dept_tms_id = tms_id;
                        }
                      "
                      placeholder="Accountable Department"
                      v-model="shipment_on_tms.shipper"
                      :options="acc_dept"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col cols="6">
                <validation-provider
                  name="Shipping type"
                  #default="{ errors }"
                  rules="required"
                >
                  <b-form-group>
                    <label>Shipping type <font class="red">*</font> </label>

                    <Select4
                      :class="errors.length > 0 ? 'is-invalid' : null"
                      :disabled="readonlyFrom"
                      placeholder="Shipping type"
                      v-model="shipment_on_tms.shipping_type"
                      @select="
                        ({ tms_id }) => {
                          shipment_on_tms.shipping_type_tms_id = tms_id;
                        }
                      "
                      :options="{
                        isSearch: true,
                        value: 'id',
                        label: 'text',
                        data:
                          service_type == 5 ||
                          (service_type == 4 &&
                            shipment_on_tms.customs_other_service_type ==
                              'CONTAINER') ||
                          service_type == 6 ||
                          (service_type == 4 &&
                            shipment_on_tms.customs_other_service_type == 'VAN')
                            ? transport_types.filter((i) =>
                                [1, 2, 3, 4].includes(i.id)
                              )
                            : transport_types.filter((i) =>
                                [1, 2].includes(i.id)
                              ),
                        fields: [{ field: 'text', label: 'Text' }],
                      }"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="6">
                <validation-provider
                  name="BK/HBL/INV"
                  #default="{ errors }"
                  rules=""
                >
                  <b-form-group>
                    <label>BK/HBL/INV </label>
                    <b-form-input
                      :state="errors.length > 0 ? false : null"
                      :disabled="readonlyFrom"
                      v-model="shipment_on_tms.bk_hbl_inv"
                      placeholder="BK/HBL/INV"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col
                cols="12"
                lg="6"
                v-if="
                  ['4'].includes(service_type) &&
                  shipment_on_tms.customs_other_service_type != 'VAN'
                "
              >
                <validation-provider
                  name="Container Type"
                  #default="{ errors }"
                  rules="required"
                >
                  <b-form-group>
                    <label>Container Type <font class="red">*</font></label>
                    <Select2
                      :class="errors.length > 0 ? 'is-invalid' : null"
                      :disabled="readonly"
                      placeholder="Container Type"
                      v-model="shipment_on_tms.cont_type"
                      :options="
                        cont_types.filter((i) => i.group === 'Container truck')
                      "
                      @select="
                        ({ tms_id }) => {
                          shipment_on_tms.cont_type_tms_id = tms_id;
                        }
                      "
                    />
                    <small class="text-danger" v-show="errors.length > 0">{{
                      errors[0]
                    }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col cols="6">
                <validation-provider
                  name="Pick up date"
                  #default="{ errors }"
                  rules="required"
                >
                  <b-form-group>
                    <label>Pick up date <font class="red">*</font></label>
                    <section>
                      <date-picker
                        ref="datePicker"
                        v-model="shipment_on_tms.from_date"
                        type="datetime"
                        :disabled="readonlyFrom"
                        class="w-full"
                        value-type="format"
                        :class="errors.length > 0 ? 'is-invalid' : null"
                        title-format="DD-MM-YYYY"
                        time-title-format="DD-MM-YYYY"
                        placeholder="Select datetime"
                        :show-time-panel="showTimePanel"
                        format="DD-MM-YYYY HH:mm"
                        @close="handleOpenChange"
                      >
                        <template v-slot:footer>
                          <button
                            class="mx-btn mx-btn-text"
                            @click="toggleTimePanel"
                          >
                            {{ showTimePanel ? "Date" : "Time" }}
                          </button>
                        </template>
                      </date-picker>
                    </section>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col cols="6">
                <validation-provider
                  name="Delivery date"
                  #default="{ errors }"
                  rules="required"
                >
                  <b-form-group>
                    <label>Delivery date <font class="red">*</font></label>

                    <section>
                      <date-picker
                        ref="datePicker"
                        v-model="shipment_on_tms.to_date"
                        :disabled-date="disabledRangeDelivery"
                        type="datetime"
                        :disabled="readonlyFrom"
                        :class="errors.length > 0 ? 'is-invalid' : null"
                        class="w-full"
                        value-type="format"
                        title-format="DD-MM-YYYY"
                        time-title-format="DD-MM-YYYY"
                        placeholder="Select datetime"
                        :show-time-panel="showTimePanel"
                        format="DD-MM-YYYY HH:mm"
                        @close="handleOpenChange"
                      >
                        <template v-slot:footer>
                          <button
                            class="mx-btn mx-btn-text"
                            @click="toggleTimePanel"
                          >
                            {{ showTimePanel ? "Date" : "Time" }}
                          </button>
                        </template>
                      </date-picker>
                    </section>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="6">
                <validation-provider #default="{ errors }" rules="">
                  <b-form-group>
                    <label>Pickup </label>

                    <Select4
                      v-model="shipment_on_tms.pickup_location"
                      :class="errors.length > 0 ? 'is-invalid' : null"
                      placeholder="Pickup"
                      :key="loadLocations"
                      @reload="$store.dispatch('masterData/fetchLocations')"
                      @select="
                        ({ tms_id }) => {
                          shipment_on_tms.pickup_location_tms_id = tms_id;
                        }
                      "
                      :disabled="readonlyFrom"
                      :options="{
                        isReload: true,
                        isSearch: true,
                        value: 'id',
                        label: 'text',
                        data: locations,
                        fields: [
                          { field: 'abbreviations', label: 'Abbreviations' },
                          { field: 'name', label: 'Location' },
                          {
                            field: 'address',
                            label: 'Address',
                          },
                        ],
                      }"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="6">
                <validation-provider #default="{ errors }" rules="">
                  <b-form-group>
                    <label>Delivery</label>

                    <Select4
                      v-model="shipment_on_tms.delivery_location"
                      :class="errors.length > 0 ? 'is-invalid' : null"
                      placeholder="Delivery"
                      @select="
                        ({ tms_id }) => {
                          shipment_on_tms.delivery_location_tms_id = tms_id;
                        }
                      "
                      :key="loadLocations"
                      @reload="$store.dispatch('masterData/fetchLocations')"
                      :disabled="readonlyFrom"
                      :options="{
                        isSearch: true,
                        isReload: true,
                        value: 'id',
                        label: 'text',
                        data: locations,
                        fields: [
                          { field: 'abbreviations', label: 'Abbreviations' },
                          { field: 'name', label: 'Location' },
                          {
                            field: 'address',
                            label: 'Address',
                          },
                        ],
                      }"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col cols="6">
                <validation-provider
                  name="Contact pick up"
                  #default="{ errors }"
                  rules=""
                >
                  <b-form-group>
                    <label>Contact pick up </label>
                    <b-form-input
                      :state="errors.length > 0 ? false : null"
                      :disabled="readonlyFrom"
                      v-model="shipment_on_tms.contact_pickup"
                      placeholder="Contact pick up"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="6">
                <validation-provider
                  name="Contact delivery"
                  #default="{ errors }"
                  rules=""
                >
                  <b-form-group>
                    <label>Contact delivery </label>
                    <b-form-input
                      :state="errors.length > 0 ? false : null"
                      :disabled="readonlyFrom"
                      v-model="shipment_on_tms.contact_delivery"
                      placeholder="Contact delivery"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <!-- VAN -->

              <span
                v-if="
                  ['6'].includes(service_type.toString()) ||
                  shipment_on_tms.customs_other_service_type == 'VAN'
                "
              >
                <b-row
                  v-for="vanContainer in shipment_on_tms.valueVan"
                  :key="vanContainer.id"
                  class="mt-1 col-12"
                >
                  <b-col lg="3">
                    <validation-provider
                      name="Container Type"
                      #default="{ errors }"
                      rules="required"
                    >
                      <b-form-group>
                        <label class="flex"
                          >Truck Type
                          <div class="red">*</div></label
                        >
                        <Select2
                          :class="errors.length > 0 ? 'is-invalid mb-1' : null"
                          :disabled="readonly"
                          :settings="{
                            allowClear: true,
                          }"
                          placeholder="Truck Type"
                          v-model="vanContainer.truck_type"
                          :options="
                            cont_types.filter((i) => i.group === 'van truck')
                          "
                        />
                        <small class="text-danger" v-show="errors.length > 0">{{
                          errors[0]
                        }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col lg="3">
                    <validation-provider
                      name="Quantity"
                      #default="{ errors }"
                      rules="required"
                    >
                      <b-form-group>
                        <label class="flex"
                          >Quantity
                          <div class="red">*</div>
                        </label>
                        <b-form-input
                          :state="errors.length > 0 ? false : null"
                          disabled
                          @input="updateVanLine3(vanContainer)"
                          class="iuput"
                          v-model="vanContainer.quantity"
                          type="text"
                          placeholder="Quantity"
                          required
                        ></b-form-input>
                        <small class="text-danger" v-show="errors.length > 0">{{
                          errors[0]
                        }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>

                  <b-col lg="3">
                    <validation-provider
                      name="Commodity Type"
                      #default="{ errors }"
                      rules="required"
                    >
                      <b-form-group>
                        <label class="flex"
                          >Commodity Type
                          <div class="red">*</div></label
                        >
                        <Select2
                          :disabled="readonly"
                          placeholder="Select Commodity type"
                          v-model="vanContainer.commodity_type"
                          :options="goods_types"
                        />
                        <small class="text-danger" v-show="errors.length > 0">{{
                          errors[0]
                        }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>

                  <select-view v-model="vanContainer.vanLine3" />

                  <b-col class="mt-20-custom" v-if="!readonly">
                    <div v-if="!vanContainer.hasDelete" class="custom-add-line">
                      <b-img
                        width="30px"
                        @click="handleAddContainer"
                        :src="iconAdd"
                        alt="logo"
                      />
                    </div>

                    <div v-if="vanContainer.hasDelete" class="custom-delete">
                      <b-img
                        width="30px"
                        @click="handleDeleteVanContainer(vanContainer.id)"
                        :src="remove"
                        alt="logo"
                      />
                    </div>
                  </b-col>
                  <b-col lg="12">
                    <b-row
                      v-for="itemVanLine in vanContainer.VanLine"
                      :key="itemVanLine.id"
                      class="mt-1"
                    >
                      <b-col lg="2">
                        <validation-provider
                          name="Commodity"
                          #default="{ errors }"
                          rules="required"
                        >
                          <b-form-group>
                            <label class="flex"
                              >Commodity
                              <div class="red">*</div>
                            </label>
                            <b-form-input
                              :state="errors.length > 0 ? false : null"
                              :disabled="readonly"
                              class="iuput"
                              v-model="itemVanLine.commodity"
                              type="text"
                              placeholder="Commodity"
                              required
                            ></b-form-input>
                            <small
                              class="text-danger"
                              v-show="errors.length > 0"
                              >{{ errors[0] }}</small
                            >
                          </b-form-group>
                        </validation-provider>
                      </b-col>

                      <b-col lg="1">
                        <validation-provider
                          name="Total packages"
                          #default="{ errors }"
                          rules="required"
                        >
                          <b-form-group>
                            <label class="flex"
                              >Total packages
                              <div class="red">*</div>
                            </label>
                            <cleave
                              :state="errors.length > 0 ? false : null"
                              :disabled="readonly"
                              :options="$Utils.CONSTANTS.cleaveNumeral"
                              v-model="itemVanLine.total_package"
                              class="form-control"
                              placeholder="Total packages"
                              required
                            />

                            <small
                              class="text-danger"
                              v-show="errors.length > 0"
                              >{{ errors[0] }}</small
                            >
                          </b-form-group>
                        </validation-provider>
                      </b-col>
                      <b-col class="custom-grid">
                        <validation-provider
                          name="Package type"
                          #default="{ errors }"
                          rule="required"
                        >
                          <b-form-group>
                            <label class="flex"
                              >Package type
                              <div class="red">*</div></label
                            >

                            <Select2
                              :disabled="readonly"
                              :class="errors.length > 0 ? 'is-invalid' : null"
                              placeholder="Package type"
                              v-model="itemVanLine.package_type"
                              :options="
                                cont_types.filter(
                                  (i) => i.group === 'packaging'
                                )
                              "
                            />
                            <small
                              class="text-danger"
                              v-show="errors.length > 0"
                              >{{ errors[0] }}</small
                            >
                          </b-form-group>
                        </validation-provider>
                      </b-col>

                      <b-col class="custom-grid">
                        <label>Dimension (cm)</label>

                        <div class="flex">
                          <validation-provider
                            name="Dimension"
                            #default="{ errors }"
                            rules="minNumber:0"
                          >
                            <b-form-group>
                              <b-form-input
                                :disabled="readonly"
                                class="iuput"
                                v-model="itemVanLine.dimension.lenght"
                                type="number"
                                placeholder="L (cm)"
                                required
                              ></b-form-input>

                              <small
                                class="text-danger"
                                v-show="errors.length > 0"
                                >{{ errors[0] }}</small
                              >
                            </b-form-group>
                          </validation-provider>

                          <validation-provider
                            name="Dimension"
                            #default="{ errors }"
                            rules="minNumber:0"
                          >
                            <b-form-group>
                              <b-form-input
                                :disabled="readonly"
                                class="iuput"
                                v-model="itemVanLine.dimension.width"
                                type="number"
                                placeholder="W (cm)"
                                required
                              ></b-form-input>
                              <small
                                class="text-danger"
                                v-show="errors.length > 0"
                                >{{ errors[0] }}</small
                              >
                            </b-form-group>
                          </validation-provider>
                          <validation-provider
                            name="Dimension"
                            #default="{ errors }"
                            rules="minNumber:0"
                          >
                            <b-form-group>
                              <b-form-input
                                :disabled="readonly"
                                class="iuput"
                                v-model="itemVanLine.dimension.height"
                                type="number"
                                placeholder="H (cm)"
                                required
                              ></b-form-input>
                              <small
                                class="text-danger"
                                v-show="errors.length > 0"
                                >{{ errors[0] }}</small
                              >
                            </b-form-group>
                          </validation-provider>
                        </div>
                      </b-col>

                      <!-- <b-col class="custom-grid">
                        <validation-provider
                          name="Dimension"
                          #default="{ errors }"
                          rules="minNumber:0"
                        >
                          <b-form-group>
                            <label>Dimension (cm)</label>

                            <div class="flex">
                              <b-form-input
                                :disabled="readonly"
                                class="iuput"
                                v-model="itemVanLine.dimension.lenght"
                                type="number"
                                placeholder="L (cm)"
                                required
                              ></b-form-input>
                              <b-form-input
                                :disabled="readonly"
                                class="iuput"
                                v-model="itemVanLine.dimension.width"
                                type="number"
                                placeholder="W (cm)"
                                required
                              ></b-form-input>
                              <b-form-input
                                :disabled="readonly"
                                class="iuput"
                                v-model="itemVanLine.dimension.height"
                                type="number"
                                placeholder="H (cm)"
                                required
                              ></b-form-input>
                            </div>
                            <small
                              class="text-danger"
                              v-show="errors.length > 0"
                              >{{ errors[0] }}</small
                            >
                          </b-form-group>
                        </validation-provider>
                      </b-col> -->
                      <b-col lg="2">
                        <validation-provider
                          name="Total gross weight (Kgs)"
                          #default="{ errors }"
                          rules="required"
                        >
                          <b-form-group>
                            <label class="flex"
                              >Total gross weight (Kgs)
                              <div class="red">*</div>
                            </label>
                            <cleave
                              :state="errors.length > 0 ? false : null"
                              :disabled="readonly"
                              :options="$Utils.CONSTANTS.cleaveNumeral"
                              v-model="itemVanLine.total_gross_weight"
                              class="form-control"
                              placeholder="Total gross weight (Kgs)"
                              required
                            />

                            <small
                              class="text-danger"
                              v-show="errors.length > 0"
                              >{{ errors[0] }}</small
                            >
                          </b-form-group>
                        </validation-provider>
                      </b-col>
                      <b-col lg="2">
                        <validation-provider
                          name="Total volume (cbm)"
                          #default="{ errors }"
                          rules="minNumber:0"
                        >
                          <b-form-group>
                            <label class="flex">Total volume (cbm) </label>
                            <cleave
                              :state="errors.length > 0 ? false : null"
                              :disabled="readonly"
                              :options="$Utils.CONSTANTS.cleaveNumeral"
                              v-model="itemVanLine.total_volume"
                              class="form-control"
                              placeholder="Total volume (cbm)"
                              required
                            />

                            <small
                              class="text-danger"
                              v-show="errors.length > 0"
                              >{{ errors[0] }}</small
                            >
                          </b-form-group>
                        </validation-provider>
                      </b-col>

                      <b-col lg="0.5" class="mt-20-custom">
                        <div
                          v-if="!itemVanLine.hasDelete && !readonly"
                          @click="handleAddLineVan(vanContainer.id)"
                          class="custom-add-line"
                        >
                          <b-img width="30px" :src="iconAdd" alt="logo" />
                        </div>
                        <div
                          v-if="itemVanLine.hasDelete && !readonly"
                          class="custom-delete"
                        >
                          <b-img
                            width="30px"
                            @click="
                              handleDeleteLineVan(
                                vanContainer.id,
                                itemVanLine.id
                              )
                            "
                            :src="remove"
                            alt="logo"
                          />
                        </div>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </span>

              <!-- END VAN -->

              <!-- LCL -->
              <span
                v-if="
                  ['3'].includes(service_type) ||
                  shipment_on_tms.customs_other_service_type == 'LCL'
                "
              >
                <div v-for="item in shipment_on_tms.showAddMore" :key="item.id">
                  <div v-if="item.hasDelete && !readonly" class="custom-delete">
                    <b-img
                      width="35px"
                      @click="handleDeleteCargo(item.id)"
                      :src="iconRemove"
                      alt="logo"
                    />
                  </div>
                  <b-row class="px-2">
                    <b-col
                      cols="12"
                      lg="12"
                      v-for="item2 in item.showAddMoreLine"
                      :key="item2.id"
                    >
                      <b-row>
                        <b-col class="custom-grid">
                          <validation-provider
                            name="No. of packages"
                            #default="{ errors }"
                            rules="required|minNumber:0"
                          >
                            <b-form-group>
                              <label class="flex"
                                >No. of packages
                                <div class="red">*</div>
                              </label>

                              <b-form-input
                                :disabled="readonly"
                                class="iuput"
                                v-model="item2.packages"
                                type="number"
                                placeholder="No. of packages"
                                required
                                @input="updatePackages(item)"
                              ></b-form-input>
                              <small
                                class="text-danger"
                                v-show="errors.length > 0"
                                >{{ errors[0] }}</small
                              >
                            </b-form-group>
                          </validation-provider>
                        </b-col>
                        <b-col class="custom-grid">
                          <validation-provider
                            name="Package type"
                            #default="{ errors }"
                            rules="required"
                          >
                            <b-form-group>
                              <label class="flex"
                                >Package type
                                <div class="red">*</div>
                              </label>

                              <Select2
                                :disabled="readonly"
                                :class="errors.length > 0 ? 'is-invalid' : null"
                                placeholder="Package type"
                                v-model="item2.package_type"
                                :options="
                                  cont_types.filter(
                                    (i) => i.group === 'packaging'
                                  )
                                "
                              />
                              <small
                                class="text-danger"
                                v-show="errors.length > 0"
                                >{{ errors[0] }}</small
                              >
                            </b-form-group>
                          </validation-provider>
                        </b-col>
                        <b-col class="custom-grid">
                          <validation-provider
                            name=" Gross weight"
                            #default="{ errors }"
                            rules="required|minNumber:0"
                          >
                            <b-form-group>
                              <label class="flex"
                                >Gross weight (kgs)
                                <div class="red">*</div>
                              </label>

                              <b-form-input
                                :disabled="readonly"
                                class="iuput"
                                v-model="item2.gross_weight"
                                type="number"
                                placeholder="Gross weight (kgs)"
                                required
                                @input="updateGrossWeight(item)"
                              ></b-form-input>
                              <small
                                class="text-danger"
                                v-show="errors.length > 0"
                                >{{ errors[0] }}</small
                              >
                            </b-form-group>
                          </validation-provider>
                        </b-col>
                        <b-col class="custom-grid">
                          <validation-provider
                            name="Volume"
                            #default="{ errors }"
                            rules="required"
                          >
                            <b-form-group>
                              <label class="flex"
                                >Volume (cbm)
                                <div class="red">*</div>
                              </label>

                              <b-form-input
                                :disabled="readonly"
                                @input="updateVolume(item)"
                                v-model="item2.volume"
                                class="iuput"
                                type="number"
                                placeholder="Volume (cbm)"
                                required
                              ></b-form-input>
                              <small
                                class="text-danger"
                                v-show="errors.length > 0"
                                >{{ errors[0] }}</small
                              >
                            </b-form-group>
                          </validation-provider>
                        </b-col>
                        <b-col class="custom-grid">
                          <label>Dimension (cm)</label>

                          <div class="flex">
                            <validation-provider
                              name="Dimension"
                              #default="{ errors }"
                              rules="minNumber:0"
                            >
                              <b-form-group>
                                <b-form-input
                                  :disabled="readonly"
                                  class="iuput"
                                  v-model="item2.dimension.lenght"
                                  type="number"
                                  placeholder="L (cm)"
                                  required
                                ></b-form-input>

                                <small
                                  class="text-danger"
                                  v-show="errors.length > 0"
                                  >{{ errors[0] }}</small
                                >
                              </b-form-group>
                            </validation-provider>

                            <validation-provider
                              name="Dimension"
                              #default="{ errors }"
                              rules="minNumber:0"
                            >
                              <b-form-group>
                                <b-form-input
                                  :disabled="readonly"
                                  class="iuput"
                                  v-model="item2.dimension.width"
                                  type="number"
                                  placeholder="W (cm)"
                                  required
                                ></b-form-input>
                                <small
                                  class="text-danger"
                                  v-show="errors.length > 0"
                                  >{{ errors[0] }}</small
                                >
                              </b-form-group>
                            </validation-provider>
                            <validation-provider
                              name="Dimension"
                              #default="{ errors }"
                              rules="minNumber:0"
                            >
                              <b-form-group>
                                <b-form-input
                                  :disabled="readonly"
                                  class="iuput"
                                  v-model="item2.dimension.height"
                                  type="number"
                                  placeholder="H (cm)"
                                  required
                                ></b-form-input>
                                <small
                                  class="text-danger"
                                  v-show="errors.length > 0"
                                  >{{ errors[0] }}</small
                                >
                              </b-form-group>
                            </validation-provider>
                          </div>
                        </b-col>
                        <!-- <b-col class="custom-grid">
                          <validation-provider
                            name="Dimension"
                            #default="{ errors }"
                            rules=""
                          >
                            <b-form-group>
                              <label>Dimension (cm)</label>

                              <div class="flex">
                                <b-form-input
                                  :disabled="readonly"
                                  class="iuput"
                                  v-model="item2.dimension.lenght"
                                  type="number"
                                  placeholder="L (cm)"
                                  required
                                ></b-form-input>
                                <b-form-input
                                  :disabled="readonly"
                                  class="iuput"
                                  v-model="item2.dimension.width"
                                  type="number"
                                  placeholder="W (cm)"
                                  required
                                ></b-form-input>
                                <b-form-input
                                  :disabled="readonly"
                                  class="iuput"
                                  v-model="item2.dimension.height"
                                  type="number"
                                  placeholder="H (cm)"
                                  required
                                ></b-form-input>
                              </div>
                              <small
                                class="text-danger"
                                v-show="errors.length > 0"
                                >{{ errors[0] }}</small
                              >
                            </b-form-group>
                          </validation-provider>
                        </b-col> -->
                        <b-col class="flex items-center mt-10">
                          <div
                            v-if="!item2.hasDelete && !readonly"
                            class="custom-add-line"
                          >
                            <b-img
                              width="30px"
                              @click="handleAddLine(item.id)"
                              :src="iconAdd"
                              alt="logo"
                            />
                          </div>
                          <div
                            v-if="item2.hasDelete && !readonly"
                            class="custom-add-line"
                          >
                            <b-img
                              width="30px"
                              @click="handleDeleteLine(item.id, item2.id)"
                              :src="remove"
                              alt="logo"
                            />
                          </div>
                        </b-col>
                      </b-row>
                    </b-col>

                    <b-col cols="12" lg="12">
                      <b-row v-if="shipment_detail.inland">
                        <b-col class="custom-grid">
                          <validation-provider
                            name="Container Type"
                            #default="{ errors }"
                            rules="required"
                          >
                            <b-form-group>
                              <label class="flex"
                                >Truck Type
                                <div class="red">*</div></label
                              >
                              <Select2
                                :class="errors.length > 0 ? 'is-invalid' : null"
                                :disabled="readonly"
                                placeholder="Truck Type"
                                :settings="{
                                  allowClear: true,
                                }"
                                v-model="item.truck_type"
                                :options="
                                  cont_types.filter(
                                    (i) => i.group === 'van truck'
                                  )
                                "
                              />
                              <small
                                class="text-danger"
                                v-show="errors.length > 0"
                                >{{ errors[0] }}</small
                              >
                            </b-form-group>
                          </validation-provider>
                        </b-col>

                        <b-col class="custom-grid">
                          <validation-provider
                            name="TruckId"
                            #default="{ errors }"
                          >
                            <b-form-group>
                              <label class="flex"
                                >Truck Id <span class="red">*</span></label
                              >
                              <div class="customTotal">
                                {{ item.lclLine3[0].truckId }}
                              </div>

                              <small
                                class="text-danger"
                                v-show="errors.length > 0"
                                >{{ errors[0] }}</small
                              >
                            </b-form-group>
                          </validation-provider>
                        </b-col>
                      </b-row>
                    </b-col>
                    <b-col class="custom-grid">
                      <validation-provider
                        name="Commodity type"
                        #default="{ errors }"
                        rules="required"
                      >
                        <b-form-group>
                          <label class="flex"
                            >Commodity type <span class="red">*</span></label
                          >

                          <Select2
                            :disabled="readonly"
                            :class="errors.length > 0 ? 'is-invalid' : null"
                            placeholder="Commodity"
                            v-model="item.commodity_type"
                            :options="goods_types"
                          />
                          <small
                            class="text-danger"
                            v-show="errors.length > 0"
                            >{{ errors[0] }}</small
                          >
                        </b-form-group>
                      </validation-provider>
                    </b-col>
                    <b-col class="custom-grid">
                      <validation-provider
                        name="Commodity"
                        #default="{ errors }"
                        rules="required"
                      >
                        <b-form-group>
                          <label class="flex"
                            >Commodity <span class="red">*</span></label
                          >

                          <b-form-input
                            :disabled="readonly"
                            class="iuput"
                            v-model="item.commodity"
                            type="text"
                            placeholder="Commodity"
                            required
                          ></b-form-input>
                          <small
                            class="text-danger"
                            v-show="errors.length > 0"
                            >{{ errors[0] }}</small
                          >
                        </b-form-group>
                      </validation-provider>
                    </b-col>
                    <b-col class="custom-grid">
                      <validation-provider
                        name="Total packages"
                        #default="{ errors }"
                      >
                        <b-form-group>
                          <label class="flex"
                            >Total packages <span class="red">*</span></label
                          >
                          <div class="customTotal">
                            {{ item.total_packages.toLocaleString() }}
                          </div>
                          <small
                            class="text-danger"
                            v-show="errors.length > 0"
                            >{{ errors[0] }}</small
                          >
                        </b-form-group>
                      </validation-provider>
                    </b-col>
                    <b-col class="custom-grid">
                      <validation-provider
                        name="Total gross weight"
                        #default="{ errors }"
                      >
                        <b-form-group>
                          <label class="flex"
                            >Total gross weight (kgs)
                            <span class="red">*</span></label
                          >
                          <div class="customTotal">
                            {{ item.gross_weight_total.toLocaleString() }}
                          </div>
                          <small
                            class="text-danger"
                            v-show="errors.length > 0"
                            >{{ errors[0] }}</small
                          >
                        </b-form-group>
                      </validation-provider>
                    </b-col>
                    <b-col class="custom-grid">
                      <validation-provider
                        name="Total volume"
                        #default="{ errors }"
                      >
                        <b-form-group>
                          <label class="flex"
                            >Total volume (cbm)
                            <span class="red">*</span></label
                          >
                          <div class="customTotal">
                            {{ item.volume_total.toLocaleString() }}
                          </div>

                          <small
                            class="text-danger"
                            v-show="errors.length > 0"
                            >{{ errors[0] }}</small
                          >
                        </b-form-group>
                      </validation-provider>
                    </b-col>
                  </b-row>
                </div>
              </span>

              <!-- END LCL -->

              <b-col cols="12">
                <validation-provider #default="{ errors }" rules="">
                  <b-form-group>
                    <label>Note 1</label>
                    <b-form-textarea
                      :disabled="readonlyFrom"
                      :state="errors.length > 0 ? false : null"
                      v-model="shipment_on_tms.note1"
                      placeholder="Note 1"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12">
                <validation-provider #default="{ errors }" rules="">
                  <b-form-group>
                    <label>Note 2 (Billing information)</label>
                    <b-form-textarea
                      :state="errors.length > 0 ? false : null"
                      :disabled="readonlyFrom"
                      v-model="shipment_on_tms.note2"
                      placeholder="Note 2 (Billing information)"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" class="pt-1 pb-1" v-if="!readonlyFrom">
                <a
                  @click="sendNewShipmentToTMS"
                  class="btn round btn-primary pl-3 pr-3"
                  ><feather-icon icon="SendIcon" /> Send To TMS</a
                >
              </b-col>
            </b-row>
          </b-card>
        </div>
      </validation-observer>
    </div>
  </div>
</template>
<style>
.red {
  color: red;
}

.vue-dropzone > .dz-preview .dz-details {
  background-color: #2b938c;
  border-radius: 15px;
}
</style>
<script>
import {
  BButton,
  BFormInput,
  BFormCheckbox,
  BFormRadioGroup,
  BFormRadio,
  BFormGroup,
  BInputGroup,
  BInputGroupAppend,
  BInputGroupPrepend,
  BFormDatepicker,
  BRow,
  BCol,
  BTable,
  BCard,
  BCardText,
} from "bootstrap-vue";

import Select2 from "v-select2-component";
import useJwt from "@/auth/jwt/useJwt";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapState, mapActions } from "vuex";
import moment from "moment";
import { checkDateToFormatDynamic } from "@/utils/format";

import { $ctx } from "@themeConfig";

export default {
  props: {
    cards: {},
    className: { default: "booking-online" },
    readonly: { default: false, type: Boolean },
    request_quotation: { default: null },
    booking: { default: null },
  },
  components: {
    BButton,
    ValidationProvider,
    BCardText,
    ValidationObserver,
    BFormInput,
    BFormCheckbox,
    BFormRadioGroup,
    BFormRadio,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BInputGroupPrepend,
    BFormDatepicker,
    BRow,
    BCol,
    BTable,
    BCard,
    BCardText,
    Select2,
    vueDropzone: vue2Dropzone,
    FeatherIcon,
  },
  data() {
    return {
      loadLocations: 0,
      wr1BranchList: [],
      iconAdd: require("@/assets/images/icons/add.png"),
      remove: require("@/assets/images/icons/remove.png"),
      cut_off: "",
      customer_list_options: [],
      isShow: false,
      showTimePanel: false,
      showTimeRangePanel: false,
      userData: JSON.parse(localStorage.getItem("userData")),
      dropzoneOptions: {
        url: $ctx.API_URL + "uploadFile",
        addRemoveLinks: true,
        createImageThumbnails: false,
        headers: { apiKey: localStorage.getItem("accessToken") },
      },
      service_type: null,
      service_type: null,
      fast_services: [
        { id: "1", text: "Import (Air)", service_type: 1 },
        { id: "2", text: "Export (Air)", service_type: 1 },
        { id: "3", text: "Import (Consol)", service_type: 2 },
        { id: "4", text: "Export (Consol)", service_type: 2 },
        { id: "5", text: "Import (Sea FCL)", service_type: 3 },
        { id: "6", text: "Export (sea FCL)", service_type: 3 },
        { id: "7", text: "Logistics", service_type: 4 },
        { id: "8", text: "Inland Trucking", service_type: 5 },
        { id: "9", text: "Inland Trucking", service_type: 6 },
      ],
      shipment_on_tms: {
        customer_name: null,
        sale_id: null,
        customer_id: null,
        shipper: null,
        cut_off: null,
      },
      shipment_detail: {},
      reloadContainerLine: 0,
    };
  },
  watch: {
    cut_off(n) {
      this.shipment_on_tms.cut_off = n;
    },
    locations: {
      handler: function (val, oldVal) {
        this.loadLocations++;
      },
      deep: true,
    },
  },
  computed: {
    ...mapState("masterData", [
      "locations",
      "service_types",
      "cont_types",
      "goods_types",
      "regions",
      "ports",
      "transport_types",
      "deports",
      "acc_dept",
      "shipping_lines",
      "sales",
      "companyItems",
    ]),
  },
  async mounted() {
    this.readonlyFrom = this.readonly;
    this.$loading.show();

    this.service_type = this.request_quotation.service_type;
    this.shipment_on_tms.id = this.request_quotation.id;
    this.shipment_on_tms.customs_other_service_type =
      this.request_quotation.customs_other_service_type || null;
    var vm = this;
    useJwt
      .get("wr1?objectType=GetBookingDetail", {
        params: { search: { id: this.request_quotation.id } },
      })
      .then((response) => {
        if (response.data.result.shipment_detail != null) {
          vm.shipment_detail = JSON.parse(response.data.result.shipment_detail);
        }
        if (response.data.result.shipment_on_tms_info != null) {
          console.log("response.data.result.shipment_on_tms_info");
          this.shipment_on_tms = JSON.parse(
            response.data.result.shipment_on_tms_info
          );
          this.shipment_on_tms.customer_company_id =
            this.request_quotation.company_id;
          this.shipment_on_tms.customer_company_name =
            this.request_quotation.customer_company_name;
          this.shipment_on_tms.phone = this.request_quotation.customer_phone;

          this.readonlyFrom = true;
          this.$nextTick(() => {
            this.isShow = true;
          });
        } else {
          this.shipment_on_tms.pricing = this.booking;
          this.shipment_on_tms.customer_name =
            response.data.result.customer_name;

          this.shipment_on_tms.phone = this.request_quotation.customer_phone;
          this.shipment_on_tms.sale_id = this.request_quotation.sale_id;
          this.shipment_on_tms.customer_id = response.data.result.customer_id;
          this.shipment_on_tms.customer_company_name =
            this.request_quotation.customer_company_name;
          this.shipment_on_tms.customer_company_id =
            this.request_quotation.company_id;
          this.request_quotation.customer_company_name;
          this.readonlyFrom = false;
          this.shipment_on_tms.sale_name = this.request_quotation.sale_name;
          this.loadDefaultInfo();
        }

        this.getListKH();

        this.isShow = true;
      });

    useJwt.get("masterData?data=Wr1Branch").then((response) => {
      if (response?.data?.result) {
        this.wr1BranchList = this.formatOptionNumberID(response.data.result);
      }
    });

    this.$loading.hide();
  },
  methods: {
    updateContainerLine3(itemCommodity, itemContainerIndex) {
      if (itemCommodity.quantity < 0) {
        itemCommodity.quantity = 0;
      } else if (itemCommodity.quantity > 99) {
        itemCommodity.quantity = 99;
      }
      const quantity = parseInt(itemCommodity.quantity);

      itemCommodity.orderDetailId =
        this.bookingId + this.pad(itemContainerIndex + 1);
      itemCommodity.containerLine3 = Array.from(
        { length: quantity },
        (_, idx) => ({
          container_no: null,
          seal_no: null,
          truckId: itemCommodity.orderDetailId + this.pad(idx + 1),
        })
      );

      this.reloadContainerLine++;
    },
    formatOption(arr) {
      const mapData = arr.map((obj) => {
        obj.text = obj.text || obj.name;
        obj.id = obj.code || obj.id;
        return obj;
      });
      return mapData;
    },
    formatOptionNumberID(arr) {
      const mapData = arr.map((obj) => {
        obj.text = obj.text || obj.name;
        obj.id = +obj.code || +obj.id;
        return obj;
      });
      return mapData;
    },
    getListKH() {
      useJwt
        .get("wr1?objectType=CustomerListCompany", {
          params: { search: this.shipment_on_tms.customer_company_id },
        })
        .then((response) => {
          this.customer_list_options = this.formatOption(response.data.result);
        });
    },
    disabledRangeDelivery: function (date) {
      if (this.request_quotation.pick_up_date) {
        var mydate = moment(this.request_quotation.pick_up_date, "DD/MM/YYYY");

        //format that date into a different format
        var now = moment(mydate).format("MM/DD/YYYY");

        return date < new Date(now);
      }
    },

    toggleTimePanel() {
      this.showTimePanel = !this.showTimePanel;
    },
    toggleTimeRangePanel() {
      this.showTimeRangePanel = !this.showTimeRangePanel;
    },
    handleCloseChange() {
      this.$refs.datePicker.popupVisible = false;
    },
    handleOpenChange() {
      this.showTimePanel = false;
    },
    handleRangeClose() {
      this.showTimeRangePanel = false;
    },
    loadDefaultInfo() {
      this.shipment_on_tms.etd = this.request_quotation.from_date;
      this.shipment_on_tms.goods_type = this.request_quotation.goods_type;

      this.shipment_on_tms.goods_type_tms_id =
        this.goods_types.find((e) => e.id == this.shipment_on_tms.goods_type)
          ?.tms_id || "";

      this.shipment_on_tms.mo_ta = this.request_quotation.mo_ta;

      this.shipment_on_tms.package_type_tms_id =
        this.cont_types.find((e) => e.id == this.request_quotation.package_type)
          ?.tms_id || "";

      this.shipment_on_tms.pol_port = this.request_quotation.pol_port;
      this.shipment_on_tms.pod_port = this.request_quotation.pod_port;

      this.shipment_on_tms.truck_type = this.request_quotation.truck_type;
      this.shipment_on_tms.so_luong = this.request_quotation.so_luong;
      this.shipment_on_tms.cont_type = this.request_quotation.cont_type;

      this.shipment_on_tms.from_date = checkDateToFormatDynamic(
        (this.shipment_detail.inland_pick_up_date ||
          this.request_quotation.inland_pick_up_date) +
          " " +
          (this.shipment_detail.inland_pick_up_time ||
            this.request_quotation.inland_pick_up_time),
        "DD-MM-YYYY HH:mm"
      );
      this.shipment_on_tms.to_date = checkDateToFormatDynamic(
        (this.shipment_detail.inland_delivery_date ||
          this.request_quotation.inland_delivery_date) +
          " " +
          (this.shipment_detail.inland_delivery_time ||
            this.request_quotation.inland_delivery_time),
        "DD-MM-YYYY HH:mm"
      );
      this.shipment_on_tms.cont_type = this.request_quotation.cont_type;
      this.shipment_on_tms.note1 = this.request_quotation.notes;
      this.shipment_on_tms.cut_off = checkDateToFormatDynamic(
        this.request_quotation.cutOffDate,
        "DD-MM-YYYY HH:mm"
      );

      this.shipment_on_tms.shipping_type =
        this.request_quotation?.showAddMore?.[0].showAddMoreLine?.[0].package_type; // long fix
      this.shipment_on_tms.amount_truck = this.request_quotation.so_luong;
      this.shipment_on_tms.contact_pickup = this.request_quotation.PICPickUp;
      this.shipment_on_tms.contact_delivery =
        this.request_quotation.PICDelivery;

      this.shipment_on_tms.pickup_location =
        this.request_quotation.pickup_location;
      this.shipment_on_tms.delivery_location =
        this.request_quotation.delivery_location;
      if (this.request_quotation.service_type == "5") {
        // this.shipment_on_tms.wr1_branch = 21;
        //Container Trucking
        if (this.shipment_detail.valueContainer) {
          this.shipment_on_tms.valueContainer =
            this.shipment_detail.valueContainer;

          if (
            this.shipment_detail.pickUpDate &&
            this.shipment_detail.pickUpTime
          ) {
            this.shipment_on_tms.from_date = checkDateToFormatDynamic(
              this.shipment_detail.pickUpDate +
                " " +
                this.shipment_detail.pickUpTime,
              "DD-MM-YYYY HH:mm"
            );
          }

          if (
            this.shipment_detail.deliveryDate &&
            this.shipment_detail.deliveryTime
          ) {
            this.shipment_on_tms.to_date = checkDateToFormatDynamic(
              this.shipment_detail.deliveryDate +
                " " +
                this.shipment_detail.deliveryTime,
              "DD-MM-YYYY HH:mm"
            );
          }
          this.shipment_on_tms.note1 = this.shipment_detail.notes_truck;

          if (
            this.shipment_details?.pickUpContact?.name &&
            this.shipment_details?.pickUpContact?.phone
          ) {
            this.shipment_on_tms.contact_pickup =
              this.shipment_details?.pickUpContact?.name +
              " " +
              this.shipment_details?.pickUpContact?.phone;
          }
          if (
            this.shipment_details?.deliveryContact?.name &&
            this.shipment_details?.deliveryContact?.phone
          ) {
            this.shipment_on_tms.contact_delivery =
              this.shipment_details?.deliveryContact?.name +
              " " +
              this.shipment_details?.deliveryContact?.phone;
          }

          //Cut-off
          if (
            this.shipment_detail.cargo_closing_date &&
            this.shipment_detail.cargo_closing_time
          ) {
            this.shipment_on_tms.cut_off = checkDateToFormatDynamic(
              this.shipment_detail.cargo_closing_date +
                " " +
                this.shipment_detail.cargo_closing_time,
              "DD-MM-YYYY HH:mm"
            );
          } else {
            this.shipment_on_tms.cut_off = checkDateToFormatDynamic(
              this.request_quotation.cargo_closing_date +
                " " +
                this.request_quotation.cargo_closing_time,
              "DD-MM-YYYY HH:mm"
            );
          }
          this.shipment_on_tms.shipping_type =
            this.shipment_detail?.shippingType ||
            this.request_quotation?.shippingType;
        } else {
          if (
            this.request_quotation.pickUpDate &&
            this.request_quotation.pickUpTime
          ) {
            this.shipment_on_tms.from_date = checkDateToFormatDynamic(
              this.request_quotation.pickUpDate +
                " " +
                this.request_quotation.pickUpTime,
              "DD-MM-YYYY HH:mm"
            );
          }
          //deliveryDate
          if (
            this.request_quotation.deliveryDate &&
            this.request_quotation.deliveryTime
          ) {
            this.shipment_on_tms.to_date = checkDateToFormatDynamic(
              this.request_quotation.deliveryDate +
                " " +
                this.request_quotation.deliveryTime,
              "DD-MM-YYYY HH:mm"
            );
          }

          // notes_truck
          this.shipment_on_tms.note1 = this.request_quotation.notes_truck;
          this.shipment_on_tms.goods_type =
            this.shipment_detail?.valueContainer?.[0]?.commodity_type ||
            this.request_quotation?.valueContainer?.[0]?.commodity_type;
          //Cut-off
          if (
            this.shipment_detail.cargo_closing_date &&
            this.shipment_detail.cargo_closing_time
          ) {
            this.shipment_on_tms.cut_off = checkDateToFormatDynamic(
              this.shipment_detail.cargo_closing_date +
                " " +
                this.shipment_detail.cargo_closing_time,
              "DD-MM-YYYY HH:mm"
            );
          } else {
            this.shipment_on_tms.cut_off = checkDateToFormatDynamic(
              this.request_quotation.cargo_closing_date +
                " " +
                this.request_quotation.cargo_closing_time,
              "DD-MM-YYYY HH:mm"
            );
          }
          this.shipment_on_tms.shipping_type =
            this.request_quotation.shippingType;

          //quantity

          if (
            this.request_quotation?.pickUpContact?.name &&
            this.request_quotation?.pickUpContact?.phone
          ) {
            this.shipment_on_tms.contact_pickup =
              this.request_quotation?.pickUpContact?.name +
              " " +
              this.request_quotation?.pickUpContact?.phone;
          }

          //contact_delivery
          if (
            this.request_quotation?.deliveryContact?.name &&
            this.request_quotation?.deliveryContact?.phone
          ) {
            this.shipment_on_tms.contact_delivery =
              this.request_quotation?.deliveryContact?.name +
              " " +
              this.request_quotation?.deliveryContact?.phone;
          }

          // long fix
        }
      } else if (this.request_quotation.service_type == "3") {
        // LCL
        if (this.shipment_detail.showAddMore) {
          this.shipment_on_tms.showAddMore = this.shipment_detail.showAddMore;

          this.shipment_on_tms.pickup_location =
            this.shipment_detail?.showAddMore?.[0]?.lclLine3?.[0]
              .pickup_location || this.request_quotation.pickup_location;
          this.shipment_on_tms.delivery_location =
            this.shipment_detail?.showAddMore?.[0]?.lclLine3?.[0]
              .delivery_location || this.request_quotation.delivery_location;
          this.shipment_on_tms.note1 = this.shipment_detail?.notes;
          if (
            this.shipment_detail.pickUpDate &&
            this.shipment_detail.pickUpTime
          ) {
            this.shipment_on_tms.from_date = checkDateToFormatDynamic(
              this.shipment_detail.pickUpDate +
                " " +
                this.shipment_detail.pickUpTime,
              "DD-MM-YYYY HH:mm"
            );
          }

          if (
            this.shipment_detail.deliveryDate &&
            this.shipment_detail.deliveryTime
          ) {
            this.shipment_on_tms.to_date = checkDateToFormatDynamic(
              this.shipment_detail.deliveryDate +
                " " +
                this.shipment_detail.deliveryTime,
              "DD-MM-YYYY HH:mm"
            );
          }
        } else {
          this.shipment_on_tms.trong_luong =
            this.request_quotation?.showAddMore?.[0].showAddMoreLine?.[0].gross_weight; // long fix
          this.shipment_on_tms.so_khoi =
            this.request_quotation?.showAddMore?.[0].showAddMoreLine?.[0].volume; // long fix
          this.shipment_on_tms.package_type =
            this.request_quotation?.showAddMore?.[0].showAddMoreLine?.[0].package_type;
          this.shipment_on_tms.so_luong =
            this.request_quotation?.showAddMore?.[0].showAddMoreLine?.[0]?.packages;

          this.shipment_on_tms.pickup_location =
            this.request_quotation.pickup_location;
          this.shipment_on_tms.delivery_location =
            this.request_quotation.delivery_location;
          // inland_contact_pick_up.name
          //inland_contact_delivery

          if (
            this.request_quotation?.door_contact_pick_up?.name &&
            this.request_quotation?.door_contact_pick_up?.phone
          ) {
            this.shipment_on_tms.contact_pickup =
              this.request_quotation?.door_contact_pick_up?.name +
              " " +
              this.request_quotation?.door_contact_pick_up?.phone;
          }

          if (
            this.request_quotation?.door_contact_delivery?.name &&
            this.request_quotation?.door_contact_delivery?.phone
          ) {
            this.shipment_on_tms.contact_delivery =
              this.request_quotation?.door_contact_delivery?.name +
              " " +
              this.request_quotation?.door_contact_delivery?.phone;
          }

          if (
            this.request_quotation?.inland_contact_pick_up?.name &&
            this.request_quotation?.inland_contact_pick_up?.phone
          ) {
            this.shipment_on_tms.contact_pickup =
              this.request_quotation?.inland_contact_pick_up?.name +
              " " +
              this.request_quotation?.inland_contact_pick_up?.phone;
          }

          if (
            this.request_quotation?.inland_contact_delivery?.name &&
            this.request_quotation?.inland_contact_delivery?.phone
          ) {
            this.shipment_on_tms.contact_delivery =
              this.request_quotation?.inland_contact_delivery?.name +
              " " +
              this.request_quotation?.inland_contact_delivery?.phone;
          }
        }
      } else if (this.request_quotation.service_type == "6") {
        // VAN
        console.log("VAN");
        if (this.shipment_detail.valueVan) {
          this.shipment_on_tms.valueVan = this.shipment_detail.valueVan;

          if (
            this.shipment_detail.pickUpDate &&
            this.shipment_detail.pickUpTime
          ) {
            this.shipment_on_tms.from_date = checkDateToFormatDynamic(
              this.shipment_detail.pickUpDate +
                " " +
                this.shipment_detail.pickUpTime,
              "DD-MM-YYYY HH:mm"
            );
          }

          if (
            this.shipment_detail.deliveryDate &&
            this.shipment_detail.deliveryTime
          ) {
            this.shipment_on_tms.to_date = checkDateToFormatDynamic(
              this.shipment_detail.deliveryDate +
                " " +
                this.shipment_detail.deliveryTime,
              "DD-MM-YYYY HH:mm"
            );
          }

          this.shipment_on_tms.note1 = this.shipment_detail.notes_truck;
          if (
            this.shipment_details?.pickUpContact?.name &&
            this.shipment_details?.pickUpContact?.phone
          ) {
            this.shipment_on_tms.contact_pickup =
              this.shipment_details?.pickUpContact?.name +
              " " +
              this.shipment_details?.pickUpContact?.phone;
          }
          if (
            this.shipment_details?.deliveryContact?.name &&
            this.shipment_details?.deliveryContact?.phone
          ) {
            this.shipment_on_tms.contact_delivery =
              this.shipment_details?.deliveryContact?.name +
              " " +
              this.shipment_details?.deliveryContact?.phone;
          }
        } else {
          this.shipment_on_tms.trong_luong =
            this.request_quotation?.valueVan?.[0].VanLine?.[0].total_gross_weight; // long fix
          this.shipment_on_tms.so_khoi =
            this.request_quotation?.valueVan?.[0].VanLine?.[0].total_volume; // long fix
          this.shipment_on_tms.so_luong =
            this.request_quotation?.valueVan?.[0].VanLine?.[0].total_package;
          this.shipment_on_tms.mo_ta =
            this.request_quotation?.valueVan?.[0].VanLine?.[0].commodity;
          this.shipment_on_tms.goods_type =
            this.request_quotation?.valueVan?.[0].VanLine?.[0].commodity_type;
          this.shipment_on_tms.truck_type =
            this.request_quotation?.valueVan?.[0].truck_type;
          this.shipment_on_tms.shipping_type =
            this.request_quotation.shippingType;

          //quantity
          this.shipment_on_tms.amount_truck =
            this.request_quotation?.valueVan?.[0].quantity;

          if (
            this.request_quotation.pickUpDate &&
            this.request_quotation.pickUpTime
          ) {
            this.shipment_on_tms.from_date = checkDateToFormatDynamic(
              this.request_quotation.pickUpDate +
                " " +
                this.request_quotation.pickUpTime,
              "DD-MM-YYYY HH:mm"
            );
          }

          if (
            this.request_quotation.deliveryDate &&
            this.request_quotation.deliveryTime
          ) {
            this.shipment_on_tms.to_date = checkDateToFormatDynamic(
              this.request_quotation.deliveryDate +
                " " +
                this.request_quotation.deliveryTime,
              "DD-MM-YYYY HH:mm"
            );
          }
          this.shipment_on_tms.note1 = this.request_quotation.notes_truck;

          if (
            this.request_quotation?.pickUpContact?.name &&
            this.request_quotation?.pickUpContact?.phone
          ) {
            this.shipment_on_tms.contact_pickup =
              this.request_quotation?.pickUpContact?.name +
              " " +
              this.request_quotation?.pickUpContact?.phone;
          }
          if (
            this.request_quotation?.deliveryContact?.name &&
            this.request_quotation?.deliveryContact?.phone
          ) {
            this.shipment_on_tms.contact_delivery =
              this.request_quotation?.deliveryContact?.name +
              " " +
              this.request_quotation?.deliveryContact?.phone;
          }
        }
      }

      this.shipment_on_tms.cont_type_tms_id =
        this.cont_types.find((e) => e.id == this.request_quotation.cont_type)
          ?.tms_id || "";

      this.shipment_on_tms.truck_type_tms_id =
        this.cont_types.find((e) => e.id == this.request_quotation.truck_type)
          ?.tms_id || "";
      // shipment_on_tms.truck_type_tms_id = tms_id

      this.shipment_on_tms.shipper =
        this.service_type == 5 ||
        this.request_quotation.has_container_trucking ||
        this.request_quotation.customs_other_service_type == "CONTAINER"
          ? 4
          : this.service_type == 6 ||
            this.request_quotation.has_van_trucking ||
            this.request_quotation.customs_other_service_type == "VAN"
          ? 5
          : null;

      this.shipment_on_tms.acc_dept_tms_id =
        this.acc_dept.find((e) => e.id == this.shipment_on_tms.shipper)
          ?.tms_id || "";

      this.shipment_on_tms.pickup_location_tms_id =
        this.locations.find((e) => e.id == this.shipment_on_tms.pickup_location)
          ?.tms_id || "";

      this.shipment_on_tms.delivery_location_tms_id =
        this.locations.find(
          (e) => e.id == this.shipment_on_tms.delivery_location
        )?.tms_id || "";

      this.shipment_on_tms.bk_hbl_inv = this.request_quotation.cargo_booking;
      this.shipment_on_tms.deport =
        this.request_quotation.deport || this.request_quotation.deport_location;

      this.shipment_on_tms.depot_tms_id =
        this.locations.filter(
          (e) =>
            e.id == this.request_quotation.deport ||
            e.id == this.request_quotation.deport_location
        )[0]?.tms_id || "";

      this.shipment_on_tms.shipping_line = this.request_quotation.shipping_line;
      this.shipment_on_tms.shipping_line_tms_id =
        this.shipping_lines.filter(
          (e) => e.id == this.request_quotation.shipping_line
        )[0]?.tms_id || "";
      this.shipment_on_tms.container_no = this.request_quotation.container_no;
      this.shipment_on_tms.seal_no = this.request_quotation.seal_no;

      this.shipment_on_tms.note2 = this.request_quotation.billingInformation;

      this.shipment_on_tms.shipping_type = this.request_quotation.shippingType;

      this.shipment_on_tms.shipping_type_tms_id =
        this.transport_types.filter(
          (i) => i.id == this.request_quotation.shippingType
        )[0]?.tms_id || "";
      this.$nextTick(() => {
        this.isShow = true;
      });
    },
    async sendNewShipmentToTMS() {
      if (
        this.shipment_on_tms.acc_dept_tms_id == undefined ||
        this.shipment_on_tms.acc_dept_tms_id == null
      ) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title:
              "Accountable Department is invalid value, please check again!",
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
        return;
      }

      var validate = await this.$refs.shipmentRules
        .validate()
        .then((success) => {
          return success;
        });
      if (!validate) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$i18n.t("notifyFormError"),
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
        return;
      }

      this.$loading.show();
      useJwt
        .put("wr1?objectType=NewShipmentToTMS", this.shipment_on_tms)
        .then((response) => {
          if (response.data.code == 200) {
            this.$emit("NewShipmentToTMS", response.data.meta?.status || 0);
            this.$emit("UpdateShipmentDetail", this.shipment_on_tms);

            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Send Shipment to TMS success!",
                icon: "CheckSquareIcon",
                variant: "primary",
              },
            });
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.message,
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          }
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Send Shipment to TMS error!",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        })
        .finally(() => {
          this.$loading.hide();
        });
    },
  },
};
</script>
